<template>
    <v-dialog v-model="openDialog" @keydown.esc="openDialog = !openDialog">
        <v-card>
            <v-card-title class="headline">
                <slot name="title"></slot>
            </v-card-title>
            <v-card-text>
                <slot name="body"></slot>
            </v-card-text>
            <v-card-actions>
                <slot name="footer"></slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props:['dialog'],
    data(){
        return{
            
        }
    },
    computed:{
        openDialog:{
            get(){
                return this.dialog
            },
            set(value){
                if(!value){
                    this.$emit('close')
                }
            }
        }
    }
}
</script>

